// @flow
import React from 'react';
import ClientContext from './ClientContext';
import feathersClient from './feathersClient';

type Props = {
  host: string,
  children?: any,
}

export default class ClientProvider extends React.Component<Props> {
  render() {
    const { host } = this.props;
    return (
      <ClientContext.Provider value={feathersClient(host)}>
        {this.props.children}
      </ClientContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/application/client/ClientProvider.js